import { TableCard } from '../../../../../components'
import { ImportacaoResumo } from '../../components/ImportacaoResumo'
import { ImportacaoErroListTable } from '../table/ImportacaoErroListTable'

export const ImportacaoErroList = () => {
  return (
    <>
      <ImportacaoResumo />
      <TableCard>
        <ImportacaoErroListTable />
      </TableCard>
    </>
  )
}
